import React, { useState } from 'react'
import { useDispatch } from 'react-redux'

import { setActionDetail } from 'redux/smartchat/details/actions'
import { setAlternativesActionDetail } from 'redux/smartchat/alternatives/actions'
import ActionCardUI from './ActionCardUI'
import { getParsedActionDetail, typesData } from 'components/SmartChatView/utils'

const ActionCard = ({ actionDetail, modalActionRef, dataWay, toggleActionModal, toggleDeleteActionModal }) => {
  const dispatch = useDispatch()
  const [isOpenOptions, setIsOpenOptions] = useState(false)
  const actionType = getParsedActionDetail({ mode: 'revert', actionDetail }).eventType
  const actionData = typesData.clientOperatorActionTypes.includes(actionDetail.actionType) ? actionDetail.actionProperties : actionDetail.eventData

  const toggleIsOpenOptions = () => setIsOpenOptions(!isOpenOptions)

  const handleActionModal = () => {
    if (!dataWay) {
      dispatch(setActionDetail(actionDetail))
    } else {
      dataWay?.type === 'alternatives' && dispatch(setAlternativesActionDetail({ alternativesId: dataWay.alternativesId, actionDetail }))
    }
    toggleActionModal({ ...modalActionRef, mode: 'update' })
    toggleIsOpenOptions()
  }

  const handleDeleteActionModal = () => {
    toggleDeleteActionModal({ ...modalActionRef, mode: 'delete' })
    toggleIsOpenOptions()
  }

  return (
    <ActionCardUI
      actionDetail={actionDetail}
      modalActionRef={modalActionRef}
      actionType={actionType}
      actionData={actionData}
      dataWay={dataWay}
      isOpenOptions={isOpenOptions}
      toggleIsOpenOptions={toggleIsOpenOptions}
      handleActionModal={handleActionModal}
      handleDeleteActionModal={handleDeleteActionModal}
    />
  )
}

export default ActionCard
